const advantages = [
  { icon: "ri-verified-badge-line", title: "原厂授权分销资质", desc: "与多家知名电子元器件品牌建立官方授权合作，保障产品原厂品质与可追溯性。" },
  { icon: "ri-stack-line", title: "10000+ SKU 现货库存", desc: "充足的现货储备，覆盖七大产品品类，满足客户快速备货与紧急采购需求。" },
  { icon: "ri-settings-3-line", title: "专业技术选型支持", desc: "资深工程师团队提供全程技术支持，为您的产品设计提供精准选型建议。" },
  { icon: "ri-truck-line", title: "高效物流交付体系", desc: "完善的仓储与物流体系，支持快速发货，准时交付率稳定保持在99.5%以上。" },
  { icon: "ri-price-tag-3-line", title: "竞争力价格体系", desc: "依托完善的供应链网络与规模采购优势，为客户提供极具竞争力的产品报价。" },
  { icon: "ri-shield-check-line", title: "严格品质管控体系", desc: "全面的质量管控流程，每批次产品均经过严格检测，确保产品品质稳定可靠。" },
];

export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top grid */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left */}
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0EA5E9]/10 mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-[#0EA5E9]" />
              <span className="text-[#0EA5E9] text-xs font-semibold tracking-wider">ABOUT US</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0D1F3C] leading-snug mb-6">
              专注电子元器件
              <br />
              <span className="text-[#0EA5E9]">十年行业深耕</span>
              <br />
              值得信赖的供应链伙伴
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              厦门格睿特电子有限公司是一家专业从事<strong>电子元器件销售与技术服务</strong>的企业，
              总部位于厦门。公司深耕行业多年，拥有完善的供应链体系与专业的技术支持团队，
              致力于为国内外客户提供高品质、高性价比的电子元器件解决方案。
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              我们的产品覆盖电容器、电感器、半导体元器件、光电元器件、热电偶/热电阻、网络变压器、保护器件七大品类，
              广泛应用于通信、消费电子、工业控制、汽车电子、新能源等领域，服务客户遍及全国各地。
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center gap-3 bg-[#F0F6FF] rounded-xl px-5 py-4 flex-1">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#0EA5E9]/20 flex-shrink-0">
                  <i className="ri-map-pin-line text-[#0EA5E9]" />
                </div>
                <div>
                  <p className="text-xs text-gray-500">公司地址</p>
                  <p className="text-sm font-semibold text-[#0D1F3C] mt-0.5">厦门市，福建省</p>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-[#F0F6FF] rounded-xl px-5 py-4 flex-1">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#0EA5E9]/20 flex-shrink-0">
                  <i className="ri-building-2-line text-[#0EA5E9]" />
                </div>
                <div>
                  <p className="text-xs text-gray-500">公司性质</p>
                  <p className="text-sm font-semibold text-[#0D1F3C] mt-0.5">有限责任公司</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden w-full h-96">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20electronics%20warehouse%20storage%20facility%20with%20organized%20shelves%20of%20electronic%20components%2C%20professional%20industrial%20environment%2C%20workers%20in%20clean%20environment%2C%20bright%20lighting%2C%20technology%20company%20interior%2C%20supply%20chain%20management&width=800&height=600&seq=geruite-about-img1&orientation=landscape"
                alt="格睿特电子仓储中心"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/30 to-transparent" />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 bg-[#0A1628] rounded-2xl p-5 shadow-xl">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#0EA5E9]/20">
                  <i className="ri-award-line text-[#0EA5E9] text-xl" />
                </div>
                <div>
                  <p className="text-white text-sm font-bold">专业认证</p>
                  <p className="text-gray-400 text-xs">正规授权分销商</p>
                </div>
              </div>
            </div>

            {/* Floating stats */}
            <div className="absolute -top-4 -right-4 bg-white rounded-2xl p-4 shadow-lg border border-gray-100">
              <p className="text-2xl font-bold text-[#0EA5E9]">7+</p>
              <p className="text-xs text-gray-500 mt-0.5">核心品类</p>
            </div>
          </div>
        </div>

        {/* Advantages grid */}
        <div>
          <h3 className="text-2xl font-bold text-[#0D1F3C] mb-2 text-center">我们的核心优势</h3>
          <p className="text-gray-500 text-sm text-center mb-10">专业服务 · 品质保障 · 高效交付</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {advantages.map((item) => (
              <div
                key={item.title}
                className="group p-6 rounded-xl border border-gray-100 bg-[#F8FBFF] hover:border-[#0EA5E9]/30 hover:bg-white transition-all duration-200"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#0EA5E9]/10 mb-4 group-hover:bg-[#0EA5E9]/20 transition-colors duration-200">
                  <i className={`${item.icon} text-[#0EA5E9] text-lg`} />
                </div>
                <h4 className="text-base font-bold text-[#0D1F3C] mb-2">{item.title}</h4>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Testimonial */}
        <div className="mt-16 bg-[#0A1628] rounded-2xl p-10 md:p-14 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#0EA5E9]/5 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="relative z-10 max-w-3xl">
            <i className="ri-double-quotes-l text-5xl text-[#0EA5E9]/30 mb-4 block" />
            <p className="text-white text-lg md:text-xl leading-relaxed font-light mb-6">
              格睿特提供的电子元器件品质稳定、交货及时，技术支持团队响应迅速，协助我们快速解决了多个选型难题，
              是我们长期信赖的核心供应链合作伙伴。
            </p>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#0EA5E9]/20">
                <i className="ri-user-line text-[#0EA5E9]" />
              </div>
              <div>
                <p className="text-white text-sm font-semibold">某知名通信设备制造商</p>
                <p className="text-gray-500 text-xs mt-0.5 flex items-center gap-1">
                  <i className="ri-checkbox-circle-fill text-green-400" />
                  已验证合作客户
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
